module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Toilet-39c31243ce50402ac261c455064e10a3.svg";